// ==========================================================================
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// Groots Core !! DO NOT DELETE !!
require('_groots.js');

// Display debug informations
window.groots.verbose = process.env.NODE_ENV === 'production' ? true : false;

// Require Groots JS-Plugins
window.groots.plugins = {
    grAccTabs:           require('grAccTabs/grAccTabs.js'),
    grDropdown:          require('grDropdown/grDropdown.js'),
    grEqualizer:         require('grEqualizer/grEqualizer.js'),
    grFormUpload:        require('grFormUpload/grFormUpload.js'),
    grFormNormalize:     require('grFormNormalize/grFormNormalize.js'),
    grFormValidation:    require('grFormValidation/grFormValidation.js'),
    grGoogleMap:         require('grGoogleMap/grGoogleMap.js'),
    // grGridExpander:      require('grGridExpander/grGridExpander.js'),
    //grLazyLoader:        require('grLazyLoader/grLazyLoader.js'),
    grNavigation:        require('grNavigation/grNavigation.js'),
    grObjectfitEmulator: require('grObjectfitEmulator/grObjectfitEmulator.js'),
    grScrollTo:          require('grScrollTo/grScrollTo.js'),
    grSVGInliner:        require('grSVGInliner/grSVGInliner.js'),
    grTable:             require('grTable/grTable.js'),
    grVideoYoutube:      require('grVideoYoutube/grVideoYoutube.js')
}; // Remove plugins you don't use from this array to not include them in your project

// ==========================================================================
// Custom Scripts
// ==========================================================================

require('./expander.js');
require('./filter-sticky.js');
require('./modal.js');
require("./modal-video.js");
require("./footer-form.js");
require("./copy-clipboard.js");
require("./banner-slider.js");
require("./typography-iframe.js");
// require('./popup-window.js');
require("magnific-popup");
require('./detect-scroll.js');

var recaptchaQuestionId;
var recaptchaPublicKey;
var newsletterFormId = '1505';

jQuery(function () {
    luminateExtend.init({
        apiKey: 'Q2F8xD8W4qAiXuYn',
        path: {
            nonsecure: 'http://action.fondationhgm.com/site/',
            secure: 'https://action.fondationhgm.com/site/'
        }
    });

    initRecaptcha();
});

function initRecaptcha() {
    luminateExtend.api.request({
        api: 'CRSurveyAPI',
        requiresAuth: true,
        data: 'method=getSurvey&v=1.0&survey_id=' + newsletterFormId,
        callback: recaptchaPublicKeyResponse
    });
}

function recaptchaPublicKeyResponse(result) {
    var surveyQuestions = result.getSurveyResponse.survey.surveyQuestions;

    $.each(surveyQuestions, function(index, question) {
        if (question.questionType === 'Captcha' && question.questionTypeData.recaptchaData.publicKey !== undefined) {
            recaptchaQuestionId = question.questionId;
            recaptchaPublicKey = question.questionTypeData.recaptchaData.publicKey;
            $.getScript("https://www.google.com/recaptcha/api.js?render=" + recaptchaPublicKey);
        }
    });
}

// jQuery cookie plugin isn't installed
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

// Success and error handling for survey submission
function surveyResponse(data) {
    if (typeof data !== 'undefined' && 'submitSurveyResponse' in data ) {
        $(".form-inscription").hide();
        $(".form-inscription__callback").show();
        $(".form-error__callback").hide();
        $(".mc_embed_signup").hide();
        // prevent displaying modal since subscription has already been done
        setCookie('g-modal-one','true',365);
        return true;
    } else {
        $(".form-inscription").hide();
        $(".form-inscription__callback").hide();
        $(".form-error__callback").show();
        $(".mc_embed_signup").hide();
        //setCookie('g-modal-one','true',1);
        console.log(data);
        return false;
    }
}

// Handle form submission
jQuery('form#mc-embedded-subscribe-form').submit(function (event) {
    event.preventDefault();

    var firstName = jQuery('input#mce-FIRSTNAME').val();
    var lastName = jQuery('input#mce-LASTNAME').val();
    var emailaddress = jQuery('input#mce-EMAIL').val();
    var lang = document.documentElement.lang.substring(0, 2) + '_CA';

    grecaptcha.ready(function() {
        grecaptcha.execute(recaptchaPublicKey, {action: 'newsletter'}).then(function(token) {
            luminateExtend.api.request({
                api: 'CRSurveyAPI',
                requiresAuth: true,
                data: 'method=submitSurvey&v=1.0&survey_id=' + newsletterFormId + '&response_format=json' + '&cons_first_name=' + firstName +
                      '&cons_last_name=' + lastName + '&cons_email=' + emailaddress + '&question_' + recaptchaQuestionId + '=' + encodeURIComponent(token) +
                      '&cons_postal_opt_in=true&cons_info_component=t&denySubmit=&s_locale=' + lang,
                callback: surveyResponse
            });
        });
    });

});

(function() {
    'use strict';

    $("html").click(function() {
        $('[gr-nav-search-trigger]').removeClass('is-active');
        $('.gr-nav__search-container').removeClass('is-active');
    });

    $(".form--newsletter .form__newsletter-btn").click(function(e) {
        e.preventDefault();
        $.magnificPopup.open({
            items: { src: "#form-inscription" },
            type: "inline",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">X</button>',
            callbacks: {
                open: function() {
                    var email = $(".form--newsletter #email").val();
                    $(".form-inscription").show();
                    $(".modal-inscription [id~='mce-EMAIL']").val(email);
                    $(".form-error__callback").hide();
                    $(".form-inscription__callback").hide();
                    // Add tracker on open
                    dataLayer.push({
                        "event": "VPV",
                        "form": "newsletter",
                        "step": "load"
                    });
                },
                close: function() {
                    $(".form-inscription").show();
                    $(".form-inscription__callback").hide();
                    $(".form-error__callback").hide();
                }
            }
        });
    });

    //Data layer track once on change
    var newsletter_fields = $('[data-newsletter-input-track]');

    if ( newsletter_fields) {
        newsletter_fields.one('focus', function(e) {
            e.stopPropagation();
            newsletter_fields.off('focus');
            dataLayer.push({
                "event": "VPV",
                "form": "newsletter",
                "step": "start"
            });
        });
    }

    //Datalayer form submit
    var newsletter_form = $('#mc-embedded-subscribe-form');

    if (newsletter_form) {
        newsletter_form.on('submit', function(e){
            dataLayer.push({
                "event": "VPV",
                "form": "newsletter",
                "step": "submit"
            });
        });
    }


    // Datalayer Donation form Submit
    var donationForm = document.getElementById('donationForm');

    if (donationForm) {

        // Data layer push on DONATION FORM START
        $('#bbox-root').one('focus', 'input, select, textarea', function (e) {
            dataLayer.push({
                "event": "VPV",
                "form": "donate",
                "step": "start"
            });
        });

        // Track amout
        var donation_value = 0; //default
        var instanceId;

        window.bboxShowFormComplete = function () {

            var csc = document.getElementById('bboxdonation_payment_txtCSC');

            if (csc) {
                csc.addEventListener("focus", getDonationValue);
            }

            function getDonationValue() {
                var selEle = document.getElementsByClassName("BBFormRadioLabelGivingLevelSelected");
                var classStr = selEle[0].previousSibling.className;
                if (classStr.indexOf('BBFormRadioGivingLevelOther') !== -1) {
                    var otherVal = document.getElementById("bboxdonation_gift_txtOtherAmountButtons").value;
                    donation_value = otherVal.replace(/\$/i, '');
                } else {
                    donation_value = selEle[0].previousSibling.value;
                }

                instanceId = document.getElementById('instanceId');

                return donation_value;
            }

        }

        var observer = new MutationObserver(function (mutations) {

            var myElement = document.getElementById('bboxdonation_divThanks');
            if (donationForm.contains(myElement)) {
                // dataLayer push when submitted is successful

                // Amount donated - donationType is a variable in the Wordpress Page wysiwyg on the form init
                dataLayer.push({
                    "event": "PV",
                    "transactionId": instanceId.value,
                    "transactionTotal": donation_value,
                    "transactionProducts": [{
                        "sku": donationType + donation_value,
                        "name": donationType,
                        "price": donation_value,
                        "quantity": 1
                    }]
                });

                // Submit
                dataLayer.push({
                    "event": "VPV",
                    "form": "donate",
                    "step": "submit"
                });

                observer.disconnect();
            }
        });

        observer.observe(donationForm, { attributes: false, childList: true, characterData: false, subtree: true });
    }

    document.addEventListener('wpcf7mailsent', function( event ) {
        $(".form-inscription").hide();
        $(".form-error__callback").hide();
        $(".form-inscription__callback").show();
    }, false);

    $(".gallery-item").magnificPopup({
        type: "image",
        gallery: {
            enabled: true
        }
    });

    $('[gr-nav-search-trigger]').click(function(e) {
        e.preventDefault();
        e.stopPropagation(); //<-- Added This
        $(this).toggleClass("is-active");
        $(this).find('+ .gr-nav__search-container').toggleClass("is-active");
        $(this).find('+ .gr-nav__search-container input[type="search"]').focus();
    });

    $('.gr-nav__search-container').on('click', '*', function(e) {
        e.stopPropagation();
    });

    $('.alpha-filter a').mouseenter(function() {
        $(this).prev().addClass("alpha-listing__emphasis");
        $(this).next().addClass("alpha-listing__emphasis");
    });

    $('.alpha-filter a').mouseleave(function() {
        $(".alpha-listing__emphasis").removeClass("alpha-listing__emphasis");
    });

    $(window).on('load', function () {
        var hash = window.location.hash;

        if (hash === "#donationForm") {
            var formAnchor =  $("#donationForm");

            if (formAnchor[0]) {
                setTimeout(function() {
                    $(document).scrollTop(formAnchor.offset().top);
                }, 1300);
            }
        }
    });

    var sharers = document.querySelectorAll('[share-link]');

    if (sharers.length) {
        for (var i = 0; i < sharers.length; i++) {
            sharers[i].addEventListener('click', function(event) {
                event.preventDefault();
                window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
                return false;
            });
        }
    }


    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    // var navOffset = $('.gr-nav--challenge');

    // if ( !navOffset) {
    //     return false;
    // }

    // var myEfficientFn = debounce(function() {
    //     var window_top = $(window).scrollTop();
    //     if (window_top > 0) {
    //         navOffset.addClass("is-active");
    //     } else {
    //         navOffset.removeClass("is-active");
    //     }
    // }, 10);

    // window.addEventListener('scroll', myEfficientFn);
})();


